import { Col, Row } from 'reactstrap'

import { IMPORT_HISTORY_TYPE } from 'api/import_history/constants'

import { NavMenu, CustomImportHistory } from 'components/common'

import { CATEGORIES } from './constants'

export const ImportHistory = () => (
  <NavMenu>
    <div className="m-3">
      <Row className="g-0 mb-3">
        <Col className="font-x-large fw-bold">インポート履歴</Col>
      </Row>
      <CustomImportHistory importHistoryType={IMPORT_HISTORY_TYPE.COMMON} categories={CATEGORIES} />
    </div>
  </NavMenu>
)
